import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import {
  PowerBiEmbedResponse,
  PowerBiReport,
  PowerBiReportApi,
} from '../models/powerbi-embed.model';

@Injectable({ providedIn: 'root' })
export class PowerBiService {
  private readonly baseUrl = environment.powerBiApiBaseUrl;

  constructor(private readonly http: HttpClient) {}

  getReports(): Observable<PowerBiReport[]> {
    return this.http
      .get<PowerBiReportApi[]>(`${this.baseUrl}/reports`)
      .pipe(map((reports) => reports.map((report) => this.toReport(report))));
  }

  getReportsByFolder(folderName: string): Observable<PowerBiReport[]> {
    const params = new HttpParams().set('folder', folderName);
    return this.http
      .get<PowerBiReportApi[]>(`${this.baseUrl}/reports`, { params })
      .pipe(map((reports) => reports.map((report) => this.toReport(report))));
  }

  getEmbedToken(reportId: string): Observable<PowerBiEmbedResponse> {
    return this.http.get<PowerBiEmbedResponse>(
      `${this.baseUrl}/embed-token/${reportId}`
    );
  }

  private toReport(report: PowerBiReportApi): PowerBiReport {
    return {
      id: report.Id,
      name: report.Name,
      embedUrl: report.EmbedUrl,
      webUrl: report.WebUrl,
    };
  }
}
